<template>
  <a-modal width="466px" class="modify-phone" :visible="show" :footer="null" @cancel="$emit('update:show', false)">
    <template v-slot:title>
      <div class="modal-title">
        绑定微信
      </div>
    </template>
    <div class="content">
      <div id="bindQrcode"></div>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    // 展示
    show: {
      type: Boolean,
      require: true,
      default: false
    },
    // 旧手机号
    redirectUri: {
      type: String,
      require: false,
      default: ''
    }
  },
  data() {
    return {
      wxloginIns: null
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.initQrCode()
      }
    }
  },
  computed: {
    ...mapState({
      info: state => state.system.orgInfo
    })
  },
  methods: {
    /**
   * 初始化微信扫码登录二维码
   * @param { Object } params 扫码登录设置项
   */
    initQrCode() {
      const _this = this
      if (!window.WxLogin) {
        const wScript = document.createElement('script')
        wScript.type = 'text/javascript'
        wScript.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
        document.body.appendChild(wScript)
      }
      setTimeout(function () {
        const redirecturi = _this.info.ocode
          ? `${_this.redirectUri || (location.origin + location.pathname)}#${_this.info.ocode}`
          : _this.redirectUri || location.href

        const data = {
          id: 'bindQrcode', // wx组建元素
          appid: 'wx29df246f3d732e97', // 微信平台开放id
          scope: 'snsapi_login',
          style: 'black', // 黑白样式
          redirect_uri: encodeURIComponent(redirecturi), // 回调地址 encodeURIComponent编码
          href:
            'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMTBweDt9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2Mge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLndhcm4ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg=='
        }
        // eslint-disable-line
        _this.wxloginIns = new window.WxLogin(data)
      }, 500)
    },
  }
}
</script>

<style lang="less" scoped>
.modify-phone {
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  .modal-title {
    text-align: center;
    font-weight: 600;
    font-size: 16px;
  }
  .phone-box {
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
      font-weight: 600;
    }
    .form-btn {
      width: 100%;
      background: #4b7dfd;
      border-radius: 5px;
    }
    .verify-code {
      display: flex;
      align-items: center;
      input {
        width: 272px !important;
        margin-right: 10px;
      }
      .verify-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f7fa;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #4b7dfd;
        flex: 1;
        height: 48px;
      }
    }
  }

  .ant-form-item {
    display: flex;
    width: 100%;
    margin-bottom: 19px;
    &.ant-form-item-with-help {
      margin-bottom: 0;
    }
    .input-box {
      display: flex;
      align-items: center;
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    /deep/ .ant-form-item-label {
      line-height: 48px;
    }
    // align-items: center;
    /deep/ .ant-form-item-control-wrapper {
      width: 100%;
      .ant-form-item-control {
        height: 100%;
        .ant-form-explain {
          font-size: 12px;
          line-height: 22px;
        }
      }
      input {
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        background: #f5f8fa;
        border-radius: 6px;
        padding-right: 30px;
      }
    }
  }
}
</style>
